import PartnershipClientAccountsPage from './PartnershipClientAccountsPage';

export default PartnershipClientAccountsPage;
